export default "__VITE_ASSET__BjQb_14H__"